module.exports = __webpack_public_path__ + "img/Remaining stock.63d1293e.svg";